import {MatDateFormats, NativeDateAdapter} from '@angular/material';


declare const moment;
export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM Y',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM Y'
  }
};

const dateNames: string[] = [];
for (let date = 1; date <= 31; date++) {
  dateNames.push(String(date));
}
export class AppDateAdapter extends NativeDateAdapter {
  format(date: any): string {
    return moment(date).format('DD-MM-YYYY');
  }

  parse(value: any): any | null {
    if (value && value.length > 10) {
      value = value.toString().substr(0, 10);
    }

    if (!moment(value, 'DD-MM-YYYY', true).isValid()) {
      return this.invalid();
    }
    return moment(value, 'DD-MM-YYYY', true).toDate();
  }

  getFirstDayOfWeek(): number {
    return 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/forms/class/app-date.adapter.ts